var calendar = null;
var eventPanelTemplate = null;

(function (w) {
    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }
})(window)

const urlParams = new URLSearchParams(window.location.search);
const venueName = urlParams.get('Venue');
var eventDate = urlParams.get("eventDate");
var filters = urlParams.get("filters");
var selectedVenue = urlParams.get("selectedVenue");
var searchTerm = urlParams.get("searchTerm");

function processDeDupeResults(results) {
    var addedIds = [];
    var filteredResults = [];
    $.each(results, function (index, value) {
        var addToArray = !($.inArray(value.eventid, addedIds) > 0);
        //console.log("Add to array : %o", addToArray );

        // If we have it don't add the event to list. If not in the array add it
        if (addToArray) {
            filteredResults.push(value);
        }
        addedIds.push(value.eventid);
    });
    return filteredResults;
}

var DateFormats = {
    short: "DD MMMM YYYY",
    long: "dddd DD.MM.YYYY HH:mm",
    UniversalDate: 'YYYY-MM-DD'
};
Handlebars.registerHelper("formatDate", function (datetime, format) {
    if (moment) {
        format = DateFormats[format] || format;
        return moment(datetime).format(format);
    } else {
        return datetime;
    }
});
Handlebars.registerHelper("isEndDateNullOrSame", function (event) {
    var start = moment(event.start);
    var end = moment(event.eventEndDate);

    var isAfter = end.isAfter(start);
    if (isAfter) {
        return ' - ' + end.format(DateFormats.short);
    } else {
        return '';
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Handlebars
    eventPanelTemplate = Handlebars.compile(document.getElementById("eventsListing").innerHTML);

    if (venueName != null) {
        data = { processEventDateSpans: true, venue: venueName, eventType: eventType, isMainCalendar: isMainCalendar, calendarNodeId: calendarNodeId };
    }
    else {
        data = { processEventDateSpans: true, eventType: eventType, isMainCalendar: isMainCalendar, calendarNodeId: calendarNodeId };
    }
    //return new Promise(function (resolve, reject) {
    //    fetch('/umbraco/surface/events/GetEvents', {
    //        body: JSON.stringify(data), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    //    })
    //        .then(function (response) {
    //            console.log('response : %o', response.json());
    //            //resolve(response.json());
    //        })
    //        .catch(error => {
    //            console.log('Failed', error);
    //            reject(error);
    //        });
    //});

    $.ajax({
        url: "/umbraco/surface/events/GetEvents",
        method: 'post',
        //data: {
        //    processEventDateSpans : true
        //    // venue: 123 DEBUG - Only one venue for testing
        //}
        data: data
    }).done(function (result) {
        result = JSON.parse(result);

        console.log('Returned results : %o', result);
        var uniqueEvents = [];
        var ids = [];
        $.each(result, function (index, value) {
            var a = ids.indexOf(value.eventid);
            if (a === -1) {
                ids.push(value.eventid);
                uniqueEvents.push(value);
            }
        });
        //console.log(ids);
        //console.log(uniqueEvents);
        if (calendarDisplay !== "Don't display calendar") {
            var calendarEl = document.getElementById('calendar');
            var today = new Date();
            calendar = new FullCalendar.Calendar(calendarEl, {
                plugins: ['interaction', 'dayGrid'],
                eventClick: function (info) {
                    info.jsEvent.preventDefault();
                    var eventName = info.event.title;
                    var url = info.event.url;
                    var eventDate = info.event.start;
                    var selectedVenue = $("#venues").val();
                    var filters = $(".calendar-filter__button.active");
                    var dateFrom = $("#dateFrom").val();
                    filters = filters.attr("data-val");
                    var searchTerm = $("#keywordSearch").val();
                    var calendarDate = $("#calendarDate").val();
                    console.log("EVENT DATE: %o", calendarDate);

                    var pageUrl = '?' + "filters=" + $("#venueTypeSelected").val() + "&venue=" + $("#venues").val()
                        + "eventDate=" + $("#calendarDate").val() + "&searchTerm=" + $("#keywordSearch").val();
                    window.history.pushState('', '', pageUrl);
                    console.log("Date From: %o", dateFrom);

                    window.location.href = url + "?eventName=" + eventName + "&eventDate=" + eventDate + "&selectedVenue=" + selectedVenue
                        + "&filters=" + filters + "&searchTerm=" + searchTerm;
                },
                customButtons: {
                    hideButton: {
                        text: 'Hide calendar',
                        click: function () {
                            $("#calendar").css("display", "none");
                            $("#showCalendar").css("display", "block");
                        }
                    }
                },
                header: {
                    left: 'hideButton,prev,next,today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay'
                },
                columnHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true },
                defaultDate: moment(new Date()).format(DateFormats.UniversalDate),
                navLinks: true,
                editable: true,
                eventLimit: 2,
                displayEventTime: false,
                eventSources: [{
                    events: result,
                    id: 'eventSet'
                }],
                defaultView: $(window).width() < 768 ? 'dayGridDay' : 'dayGridWeek',
                contentHeight: 500,
                views: {
                    dayGridWeek: {
                        eventLimit: 50
                    }
                }
            });

            if (searchTerm != null && searchTerm != "0") {
                $("#keywordSearch").val(searchTerm);
            }

            if (selectedVenue != null) {
                $("#venues").val(selectedVenue);
            }

            if (filters != null) {
                $("#filter__all").removeClass("active");
                $('[data-val=' + filters + ']').addClass("active");
                $("#venueTypeSelected").val(filters);
            }

            calendar.render();

            if (eventDate != null) {
                calendar.gotoDate(moment(eventDate).format(DateFormats.UniversalDate));
            }

            $('.fc-day-header a').html(function (i, t) {
                var words = t.split(/\s+/);
                return "<span>" + words.slice(0, 1).join(" ") + "</span> " + words.slice(1).join(" ");
            });
        }

        doVenueFilter(true);

        // Render the event panels at the bottom
        if (!hideEventListingCards) {
            var html = eventPanelTemplate(processDeDupeResults(uniqueEvents));
            $('#eventsListingOutput').html(html);
        }
    });

    $('body').on('click', 'button.fc-prev-button', function () {
        $('#dateFrom').val('');
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }
        console.log("CALENDAR DATE: %o", calendar.getDate());

        var pageUrl = '?' + "filters=" + $("#venueTypeSelected").val() + "&venue=" + $("#venues").val() + "&eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);
    });

    $('body').on('click', 'button.fc-next-button', function () {
        $('#dateFrom').val('');
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }
        console.log("DATEEE: %o", $("#calendarDate").val());

        var pageUrl = '?' + "filters=" + $("#venueTypeSelected").val() + "&venue=" + $("#venues").val() + "&eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);
    });

    $('.calendar-filter__button:not(.calendar-filter-audience__button)').click(function (e) {
        e.preventDefault();
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }

        var pageUrl = '?' + "filters=" + $(this).attr("data-val") + "&venue=" + $("#venues").val() + "&eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);

        var me = $(this);
        $('.calendar-filter__button:not(.calendar-filter-audience__button)').removeClass('active');
        me.addClass("active");

        var val = me.attr('data-val');
        $('#venueTypeSelected').val(val);
        $('#dateFrom').val('');
        $("#keywordSearch").val('');
        doVenueFilter();
    });


    $('.calendar-filter-holiday__button').click(function (e) {
        e.preventDefault();
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }

        var pageUrl = '?' + "filters=" + $(this).attr("data-val") + "&venue=" + $("#venues").val() + "&eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);

        var me = $(this);
        $('.calendar-filter-holiday__button').removeClass('active');
        me.addClass("active");

        var val = me.attr('data-val');
        $('#holidayVenueTypeSelected').val(val);
        $('#dateFrom').val('');
        $("#keywordSearch").val('');
        doVenueFilter();
    });

    $('.calendar-filter-holiday-agegroup__button').click(function (e) {
        e.preventDefault();
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }

        var pageUrl = '?' + "filters=" + $(this).attr("data-val") + "&venue=" + $("#venues").val() + "&eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);

        var me = $(this);
        $('.calendar-filter-holiday-agegroup__button').removeClass('active');
        me.addClass("active");

        var val = me.attr('data-val');
        $('#holidayAgeGroupSelected').val(val);
        $('#dateFrom').val('');
        $("#keywordSearch").val('');
        doVenueFilter();
    });

    $('#venues').change(function (e) {
        if (calendar) { $("#calendarDate").val(calendar.getDate()); }
        var pageUrl = '?' + "filters=" + $("#venueTypeSelected").val() + "&venue=" + $("#venues").val() + "eventDate=" + $("#calendarDate").val();
        window.history.pushState('', '', pageUrl);

        $("#calendar").css("display", "none");
        $("#showCalendar").css("display", "block");

        $('#dateFrom').val('');
        $("#keywordSearch").val('');
        doVenueFilter();
        scrollToCalendar();
    });
    //$('#dateFrom').change(function (e) {
    //    //$('#dateFrom').val('');
    //    //$("#keywordSearch").val('');
    //    doVenueFilter();

    //});

    $('.calendar-filter__button-sports').click(function (e) {
        console.log("Sports button clicked");
    });

    $('.calendar-filter-audience__button').click(function (e) {
        e.preventDefault();
        var me = $(this);
        $('.calendar-filter-audience__button').removeClass('active');
        me.addClass('active');
        var val = me.attr('data-val');
        $('#audienceTypeSelected').val(val);
        $('#dateFrom').val('');
        $('#keywordSearch').val('');
        doVenueFilter();
    });

    $("#showCalendar").click(function (e) {
        $("#calendar").css("display", "block");
        $("#showCalendar").css("display", "none");
        $("#hideCalendar").css("display", "block");
    });
    $("#hideCalendar").click(function (e) {
        $("#calendar").css("display", "none");
        $("#showCalendar").css("display", "block");
        $("#hideCalendar").css("display", "none");
    });

    $('#calendar-clear-button').click(function (e) {
        // Clear filters/search
        //console.log("Clear button clicked");
        $('.calendar-filter__button').removeClass('active');
        $('.calendar-filter-audience__button').removeClass('active');
        $("#filter__all").addClass("active");
        if ($('#filter__all__audience').length) $("#filter__all__audience").addClass("active");
        $('#venueTypeSelected').val('0');
        if ($('#audienceTypeSelected').length) $('#audienceTypeSelected').val('0');
        $("#keywordSearch").val('');
        $('#venues').val('0');
        $('#dateFrom').val('');
        $('#dateFromFormatted').val('');
        doVenueFilter();
        //calendar.gotoDate(moment(today).format(DateFormats.UniversalDate));
    });

    // Do date pickers
    var options = {
        language: 'en',
        dateFormat: 'dd/mm/yyyy',
        altField: '#dateFromFormatted',
        altFieldDateFormat: 'yyyy-mm-dd',
        autoClose: true,
        onSelect: function (formattedDate, date, inst) {
            //var inputVal = $("#dateFrom").val();
            //if (inputVal != null && date != null) {
            //    //if (date != null) {
            //    var newDate = moment(date).format(DateFormats.UniversalDate);
            console.log("DATE: %o", date)
            if (date != "") {
                console.log("here");
                calendar.gotoDate(moment(date).format(DateFormats.UniversalDate));
            }

            //    doVenueFilter();
            //    //}
            //}
            //console.log("Date selected");
        }
    };
    $('#dateFrom').datepicker(options);

    //Search with enter key
    var input = document.getElementById("keywordSearch");
    input.addEventListener("keydown", function (e) {
        if (e.keyCode == 13) {
            $("#calendar").css("display", "none");
            $("#showCalendar").css("display", "block");
            $("#hideCalendar").css("display", "none");

            $("#filter__all").addClass("active");
            $('#venueTypeSelected').val('0');
            $('#venues').val('0');
            doVenueFilter();

            scrollToCalendar();
        }
    });

    //const eventTypes = urlParams.get('eventTypes');
    //console.log("PARAMS: %o %o", venueName, eventTypes);
    if (venueName == null) {
    }
    else if (venueName != "") {
        $('#venues').val(venueName);
    }
    if (calendarDisplay === "Show calendar on load") {
        $("#calendar").show();
        $("#showCalendar").hide();
        $("#hideCalendar").show();
    } else {
        // "Collapse calendar on load" (default) — show the Show calendar button
        // "Don't display calendar" — button not rendered in HTML so these are no-ops
        $("#calendar").hide();
        $("#showCalendar").show();
        $("#hideCalendar").hide();
    }
    //doVenueFilter();
    //eventTypes = eventTypes.split(",");
    //var eventTypesArray = eventTypes.split(",");
});

function resetSearch() {
    $("#filter__all").addClass("active");
    $("#filter__all__age").addClass("active");
    $('#venueTypeSelected').val('0');
    $('#venues').val('0');
    $("#calendar").css("display", "none");
    $("#showCalendar").css("display", "block");
}

function scrollToCalendar() {
    $("body,html").animate(
        {
            scrollTop: $("#eventsListingOutput").offset().top + -200
        },
        600 //speed
    );
}

function doVenueFilter(useQueryStringDate) {
    //console.log('Filter');
    var params = {};
    params.processEventDateSpans = true;
    params.eventType = eventType ?? "Events";
    if ($('#venues').val() !== '0') {
        params.venue = $('#venues').val();
    }

    if ($('#dateFromFormatted').val() !== '') {
        var startMoment = moment($('#dateFromFormatted').val(), DateFormats.UniversalDate);
        params.fromDate = startMoment.format(DateFormats.UniversalDate);
        params.toDate = startMoment.add(4, 'weeks').format(DateFormats.UniversalDate);
    } else if (calendar) {
        params.fromDate = moment(calendar.view.activeStart).format(DateFormats.UniversalDate);
        params.toDate = moment(calendar.view.activeEnd).format(DateFormats.UniversalDate);
    } else {
        // No calendar (Don't display calendar) — show all upcoming events
        params.fromDate = moment().format(DateFormats.UniversalDate);
        params.toDate = moment().add(1, 'year').format(DateFormats.UniversalDate);
    }

    if ($('#keywordSearch').val() !== '' && $('#keywordSearch').val() !== '0') {
        params.searchTerm = $('#keywordSearch').val();
    }
    params.isMainCalendar = isMainCalendar;
    params.calendarNodeId = calendarNodeId;
    if ($('#venueTypeSelected').val() !== '') {
        params.venueTypes = [$('#venueTypeSelected').val()];
    }
    if ($('#audienceTypeSelected').length && $('#audienceTypeSelected').val() !== '' && $('#audienceTypeSelected').val() !== '0') {
        params.audienceTypes = [$('#audienceTypeSelected').val()];
    }

    console.log('1 Params : %o', params);

    $.ajax({
        url: "/umbraco/surface/events/GetEvents",
        method: 'post',
        data: params
    }).done(function (result) {
        result = JSON.parse(result);

        var uniqueEvents = [];
        var ids = [];
        $.each(result, function (index, value) {
            var a = ids.indexOf(value.eventid);
            if (a === -1) {
                ids.push(value.eventid);
                uniqueEvents.push(value);
            }
        });

        console.log('Returned results filter : %o', result);
        console.log("VENUES VAL: %o", $("#venues").val());

        if (calendar) {
            var es = calendar.getEventSourceById('eventSet');
            es.remove();

            var eventSource = {
                events: result,
                id: 'eventSet'
            };

            calendar.addEventSource(eventSource);
            calendar.render();

            if (eventDate != null && useQueryStringDate === true) {
                calendar.gotoDate(moment(eventDate).format(DateFormats.UniversalDate));
            } else if (result.length > 0) {
                var d = new Date();
                calendar.gotoDate(moment(d, "YYYY/MM/DD").format(DateFormats.UniversalDate));
                console.log("Jumping to today's date");
            }
        }

        // Render the event panels at the bottom
        if (!hideEventListingCards) {
            var html = eventPanelTemplate(processDeDupeResults(uniqueEvents));
            $('#eventsListingOutput').html(html);
        }
    });
}
function jumpToDate(date) {
    console.log("CALENDAR: %o", calendar);
    calendar.gotoDate(moment(date).format(DateFormats.UniversalDate));
}